import { api, ApiError } from './api'

type Query = Record<string, string | number | boolean | undefined>

const buildQuery = (query: Query = {}) => {
  const params = new URLSearchParams()
  Object.entries(query).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') {
      params.append(key, String(value))
    }
  })
  const suffix = params.toString() ? `?${params.toString()}` : ''
  return suffix
}

class AdminService {
  async getDashboard(range?: { start?: string | undefined; end?: string | undefined }) {
    const suffix = buildQuery({ start: range?.start, end: range?.end })
    return await api.get(`/admin/dashboard${suffix}`)
  }

  async listUsers(query: Query = {}) {
    const suffix = buildQuery(query)
    return await api.get(`/admin/users${suffix}`)
  }

  async getUser(userId: string) {
    if (!userId) throw new ApiError('User ID required', 400)
    return await api.get(`/admin/users/${userId}`)
  }

  async updateUserStatus(userId: string, payload: Record<string, unknown>) {
    if (!userId) throw new ApiError('User ID required', 400)
    return await api.patch(`/admin/users/${userId}/status`, payload)
  }

  async listCompanies(query: Query = {}) {
    const suffix = buildQuery(query)
    return await api.get(`/admin/companies${suffix}`)
  }

  async getCompany(companyId: string) {
    if (!companyId) throw new ApiError('Company ID required', 400)
    return await api.get(`/admin/companies/${companyId}`)
  }

  async listFilings(query: Query = {}) {
    const suffix = buildQuery(query)
    return await api.get(`/admin/filings${suffix}`)
  }

  async getFiling(filingId: string) {
    if (!filingId) throw new ApiError('Filing ID required', 400)
    return await api.get(`/admin/filings/${filingId}`)
  }

  async listTransactions(query: Query = {}) {
    const suffix = buildQuery(query)
    return await api.get(`/admin/payments/transactions${suffix}`)
  }

  async listAdmins(query: Query = {}) {
    const suffix = buildQuery(query)
    return await api.get(`/admin/admins${suffix}`)
  }

  async createAdmin(payload: Record<string, unknown>) {
    return await api.post('/admin/admins', payload)
  }

  async updateAdminStatus(adminId: string, payload: Record<string, unknown>) {
    if (!adminId) throw new ApiError('Admin ID required', 400)
    return await api.patch(`/admin/admins/${adminId}/status`, payload)
  }
}

const adminService = new AdminService()
export default adminService
